import { AuctionResource } from 'app/_resources/auction.resource';
import { UtilService } from 'app/_services/util.service';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import { ConfirmModal } from 'app/_services/confirm-modal.factory';
import { AuctionsOverviewService } from 'app/_services/auctions-overview.service';
import { ConversionService } from 'app/_directives/conversionService';
import * as angular from 'angular';
import { Growl } from 'angular/custom/services/growl.service';
import { ComfortBidDtoWithConfig } from '../custom';

class ComfortBidEditComponentCtrl implements ng.IController {
    comfortBidId: number;

    comfortBid: ComfortBidDto;
    loading: boolean;
    loadingErrMsg: string;
    submitting: boolean;

    constructor(
        private auctionResource: AuctionResource,
        private utilService: UtilService,
        private errorHandler: ErrorHandler,
        private confirmModal: ConfirmModal,
        private auctionsOverviewService: AuctionsOverviewService,
        private $location: ng.ILocationService,
        private growl: Growl,
        private conversionService: ConversionService
    ) {}

    $onInit(): void {
        this.loading = true;

        this.auctionResource
            .comfortBid(
                { id: this.comfortBidId },
                (res: ComfortBidDto) => {
                    this.comfortBid = res;
                },
                (err: ng.IHttpPromiseCallbackArg<RestError>) => {
                    this.loadingErrMsg =
                        err && err.data && err.data.message
                            ? err.data.message
                            : 'An unknown error occurred. Please, check back later.';
                }
            )
            .$promise.finally(() => (this.loading = false));
    }

    submit(form: ng.IFormController): void {
        if (!form.$valid) {
            return;
        }

        if (
            !this.conversionService.validateConversionAndUpgradeAreNotBothActiveForTheSameNetworkPoint(
                this.comfortBid.conversions && this.comfortBid.conversions[0]
                    ? this.comfortBid.conversions[0].conversion0
                    : undefined,
                this.comfortBid.conversions && this.comfortBid.conversions[0]
                    ? this.comfortBid.conversions[0].conversion1
                    : undefined,
                this.comfortBid.upgrade0,
                this.comfortBid.upgrade1
            )
        ) {
            this.growl.show(
                'It is not possible to upgrade and convert capacity at the same network point.',
                'danger',
                { timestamp: false }
            );
            return;
        }

        this.submitting = true;

        this.auctionResource
            .updateComfortBid(
                this.utilService.sanitize<
                    ComfortBidDtoWithConfig,
                    ComfortBidDto
                >(this.comfortBid),
                () => {
                    this.auctionsOverviewService.comfortBidUpdatedSuccessfully =
                        true;
                    this.$location.path('/auctions');
                },
                (err: ng.IHttpPromiseCallbackArg<RestError>) => {
                    if (
                        !!err.data &&
                        !!err.data.status &&
                        err.data.status === 403
                    ) {
                        err.data.message =
                            'You are not authorized to change this bid.';
                    }
                    this.errorHandler(err);
                }
            )
            .$promise.finally(() => (this.submitting = false));
    }

    withdrawBid(): void {
        this.confirmModal(
            'Do you really want to delete this comfort bid?'
        ).result.then(() => {
            this.auctionResource.deleteBid(
                { id: this.comfortBid.id },
                () => {
                    this.auctionsOverviewService.comfortBidWithdrawnSuccessfully =
                        true;
                    this.$location.path('/auctions');
                },
                this.errorHandler
            );
        });
    }
}

angular.module('app').component('pkpComfortBidEdit', {
    controller: ComfortBidEditComponentCtrl,
    template: require('app/comfort-bid/comfort-bid-edit.component.html'),
    bindings: {
        comfortBidId: '<'
    }
});
